   // check4dnr/src/components/ProtectedRoute.js
   import React, { useContext } from 'react';
   import { Navigate, useLocation } from 'react-router-dom';
   import { UserContext } from '../context/UserContext';

   function ProtectedRoute({ children }) {
     const { userGuid, accessToken } = useContext(UserContext);
     const location = useLocation();

     if (!userGuid || !accessToken) {
       // User is not authenticated
       return (
        <Navigate 
        to="/login" 
        state={{ 
          redirectAfterLogin: location.pathname + location.search,
          message: 'Please log in to access this page'
        }} 
        replace 
      />
       );
     }

     return children;
   }

   export default ProtectedRoute;